module.exports = __webpack_public_path__ + "media/images/logo-fb5938b342813d5b1d5f11a4f79eac95.png";